export const ExperimentAPINames = {
  HigherPaywall: "Higher Paywall",
  PaywallMasking: "Paywall Masking",
  PlusDiscoveryWidgetForSubscribers: "Plus Discovery widget for subscribers",
  SubNavTrendingLabel: "SubNav Trending Label",
  VelocityWallThreshold: "Velocity Wall Threshold",
};
